import React from 'react';
import { Link } from 'react-router-dom';
import { Upload, FileText, Gavel, Wallet, ArrowRight, Clock, ShieldCheck } from 'lucide-react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

const Werkwijze = () => {
  const steps = [
    { icon: Upload, title: 'Upload je boete', desc: 'Foto of PDF van je beschikking. Wij nemen automatisch alle relevante gegevens over: NAW, beschikkingsnummer, kenteken, datum, bedrag, omschrijving overtreding en uiterlijke bezwaartermijn.' },
    { icon: FileText, title: 'Controle & ondertekening', desc: 'Jij controleert de overgenomen gegevens. Onderteken digitaal de volmacht zodat wij namens jou kunnen optreden.' },
    { icon: Gavel, title: 'Wij dienen bezwaar in', desc: 'Onze juristen stellen een gefundeerd bezwaarschrift op en dienen dit binnen de wettelijke termijn in bij de juiste instantie.' },
    { icon: Wallet, title: 'Uitkomst', desc: 'Boete vernietigd? Jij krijgt het bedrag terug. Verliezen we? Jij betaalt ons niets. No cure, no pay.' },
  ];
  return (
    <div>
      <section className="hero-gradient text-white py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h1 className="text-4xl md:text-5xl font-bold">Zo werken wij</h1>
          <p className="text-slate-200 mt-4 text-lg max-w-2xl">Van upload tot uitspraak - wij nemen het hele traject uit handen. Transparant, snel en risicovrij.</p>
        </div>
      </section>
      <section className="py-14 max-w-5xl mx-auto px-4 md:px-6">
        <div className="space-y-6">
          {steps.map((s, i) => (
            <Card key={i} className="p-6 md:p-8 border border-slate-200 flex flex-col md:flex-row items-start gap-6">
              <div className="w-14 h-14 rounded-xl bg-[#1e1b4b] flex items-center justify-center flex-shrink-0">
                <s.icon className="w-6 h-6 text-[#f26b1f]" />
              </div>
              <div className="flex-1">
                <div className="text-xs text-[#f26b1f] font-semibold uppercase tracking-widest">Stap {i+1}</div>
                <div className="text-xl font-bold text-[#1e1b4b] mt-1">{s.title}</div>
                <p className="text-slate-700 mt-2 leading-relaxed">{s.desc}</p>
              </div>
            </Card>
          ))}
        </div>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          <Card className="p-6 border border-slate-200">
            <Clock className="w-6 h-6 text-[#f26b1f]" />
            <div className="font-bold text-[#1e1b4b] mt-2">Termijncontrole</div>
            <p className="text-sm text-slate-600 mt-1">Onze juristen berekenen automatisch je bezwaartermijn (meestal 6 weken) en waarschuwen je bij dreigende overschrijding.</p>
          </Card>
          <Card className="p-6 border border-slate-200">
            <ShieldCheck className="w-6 h-6 text-[#f26b1f]" />
            <div className="font-bold text-[#1e1b4b] mt-2">AVG-conform</div>
            <p className="text-sm text-slate-600 mt-1">End-to-end versleutelde opslag van al je documenten. Wij delen niets zonder jouw toestemming.</p>
          </Card>
        </div>
        <div className="mt-12 text-center">
          <Link to="/indienen">
            <Button size="lg" className="bg-[#f26b1f] hover:bg-[#d4581a] text-white h-12 px-8">Start nu gratis <ArrowRight className="w-4 h-4 ml-2" /></Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Werkwijze;
